import './CustomPacingScheduleDropdownButtons.scss';

import React from 'react';

import Tooltip from '../../../../common/Tooltip';
import bem from '../../../../utils/bem';
import type { CustomPacingPacingScheduleDropdownButtonConfig } from '../types';

export type CustomPacingScheduleDropdownButtonsProps = {
  toggleOpen: () => void;
  options: CustomPacingPacingScheduleDropdownButtonConfig[];
};

const [block, element] = bem('custom-pacing-schedule-dropdown-buttons');

const CustomPacingScheduleDropdownButtons = ({
  options,
  toggleOpen,
}: CustomPacingScheduleDropdownButtonsProps): React.JSX.Element => {
  return (
    <section className={block()} data-testid="pacing-schedule-dropdown-buttons">
      {options.map(({ label, onClick, isDisabled, id, ariaLabel, dataTestId, tooltipProps }) => (
        <Tooltip
          key={id}
          id={tooltipProps?.id ?? ''}
          message={tooltipProps?.message ?? ''}
          disable={tooltipProps?.isDisabled}
          shouldRenderInPortal={false}
          className={element('tooltip')}
        >
          <button
            key={id}
            className={element('option')}
            data-testid={dataTestId}
            aria-label={ariaLabel}
            type="button"
            disabled={isDisabled}
            onClick={(): void => {
              onClick();
              toggleOpen();
            }}
          >
            {label}
          </button>
        </Tooltip>
      ))}
    </section>
  );
};

export default CustomPacingScheduleDropdownButtons;
